
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IRichMenu, IRichMenuContent } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:closeModal'],
})
export default class RichMenuPreviewModal extends Vue {
  @Prop()
  modalVisible!: boolean

  @Prop()
  richMenu!: IRichMenu

  richMenuContent: IRichMenuContent | null = null

  get visible() {
    return this.modalVisible
  }

  set visible(value) {
    this.$emit('update:closeModal', value)
  }
}
